<template>
    <section class="home-section">
        <section-title :title="title"></section-title>
        <section class="bg-mix">
            <report-window
                endpoint="/reports/flight_data"
                :perPage="100"
                :fields="fields"
                :title="title"
                :headers="headers"
                :current.sync="current"
                :columnClick="columnClick"
                :templates="templates"
                :fieldClasses="fieldClasses"
            ></report-window>
            <flight-info
                v-if="flight"
                :flight="flight"
                @close="flight = null"
            ></flight-info>
        </section>
    </section>
</template>

<script>
import ReportWindow from "@/components/tools/ReportWindow";
import FlightInfo from "@/components/flight/FlightInfo";
const moment = require("moment");
export default {
    name: "past-data-report",
    props: ["options"],
    components: {
        'report-window': ReportWindow,
        'flight-info': FlightInfo,
    },
    mounted: function() {
        for (let field of this.fields) {
            if (field.defValue) {
                this.current[field.name] = field.defValue;
            } else {
                this.current[field.name] = null;
            }
        }
        if (this.options) {
            for (let field of this.fields) {
                if (this.options[field.name]) {
                    field.defValue = this.options[field.name];
                    this.current[field.name] = this.options[field.name];
                }
            }
        }
        this.fields = Object.assign([], this.fields);
    },
    data() {
        return {
            current: {},
            flight: null,
            ready: false,
            fields: [
                {
                    name: "FromDate",
                    editor: "date",
                    label: "Date From",
                    columns: 2
                },
                {
                    name: "ToDate",
                    editor: "date",
                    label: "Date To",
                    columns: 2
                },
                {
                    name: "FlightFromDate",
                    editor: "date",
                    label: "Flight Date From",
                    columns: 2,
                    required: true,
                },
                {
                    name: "FlightToDate",
                    editor: "date",
                    label: "Flight Date To",
                    columns: 2,
                    required: true,
                },
                {
                    name: "Origin",
                    editor: "text",
                    label: "From",
                    columns: 2
                },
                {
                    name: "Destination",
                    editor: "text",
                    label: "To",
                    columns: 2
                },
            ],
            title: "Past Data",
            headers: {
            },
            templates: [
                {
                    name: "date",
                    callback: function(row) {
                        if (!row.date) return "";
                        return moment(row.date).format("DD/MM/YYYY HH:mm");
                    }
                },
                {name: 'departure_date', callback: function(row) {
                        return moment(row.departure_date).format("DD/MM/YYYY");
                    }
                },
            ],
            columnClick: {
                number: this.showFlight,
            },
            fieldClasses: {
                number: function(row) {
                    return 'cursor-pointer-report';
                },
            },
        };
    },
    methods: {
        showFlight (row) {
            this.flight = row;
        }
    }
};
</script>
